var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{attrs:{"id":"header"}},[_c('img',{staticClass:"logo",attrs:{"src":"/assets/logo.svg","width":"180","height":"37"}}),(_vm.back)?_c('a',{staticClass:"btn-back",attrs:{"href":"/"},on:{"click":function($event){$event.preventDefault();return _vm.goBack.apply(null, arguments)}}},[_vm._v("Back")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }